import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {Role} from './user';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const roles = route.data.auth?.requiresOneOfRoles || [] as Array<Role>;
    return this.authService.getUser$()
      .pipe(map(user => {
          if (user.isAuthenticated()) {
            return user.hasOneOfRoles(roles) ? true : this.router.parseUrl('/geen-toegang');
          }
          return this.router.parseUrl('/aanmelden');
        })
      );
  }
}
